<template>
  <div>
    <dl class="flex">
      <dt class="flex0">疾病名称：</dt>
      <dd class="flex1">{{ consult.illnessName }}</dd>
    </dl>
    <dl class="flex">
      <dt class="flex0">患病时长：</dt>
      <dd class="flex1">{{ consult.illnessTime }}</dd>
    </dl>
    <dl class="flex">
      <dt class="flex0">病情主诉：</dt>
      <dd class="flex1">{{ consult.consultContent }}</dd>
    </dl>
    <dl class="flex" v-if="consult.supplementContent">
      <dt class="flex0">补充资料：</dt>
      <dd class="flex1">{{ consult.supplementContent }}</dd>
    </dl>
    <dl class="flex">
      <dt class="flex0">续方药品：</dt>
      <dd class="flex1"></dd>
      <dd class="flex0 color_main" @click="handler">我的处方
        <v-icon-arrow-right></v-icon-arrow-right>
      </dd>
    </dl>
    <dl class="flex" v-if="info.medicalOpinion">
      <dt class="flex0">诊疗意见：</dt>
      <dd class="flex1">{{ info.medicalOpinion }} <br/>如有不适，请及时到线下医院就诊
      </dd>
    </dl>

    <dl class="flex mt10">
      <dt class="flex0">体重：</dt>
      <dd class="flex1">{{ consult.consulterWeight }}Kg</dd>
    </dl>
    <dl class="flex">
      <dt class="flex0">肝功能：</dt>
      <dd class="flex1" :class="{color_red:isYichang(consult.liverFunction)}">{{ consult.liverFunction }}</dd>
    </dl>
    <dl class="flex">
      <dt class="flex0">肾功能：</dt>
      <dd class="flex1" :class="{color_red:isYichang(consult.kidneyFunction)}">{{ consult.kidneyFunction }}</dd>
    </dl>
    <dl class="flex">
      <dt class="flex0">生育状态或计划：</dt>
      <dd class="flex1">{{ consult.fertilityPlan || '无' }}</dd>
    </dl>
    <dl class="flex">
      <dt class="flex0">过敏史：</dt>
      <dd class="flex1" :class="{color_red:consult.allergyHistory}">{{ consult.allergyHistory }}</dd>
    </dl>
  </div>
</template>

<script>
import VIconArrowRight from "../../../plugins/v-icon-arrow-right";
import {thirdService} from "@/services/third";
import {queryStrBuilder} from "@/lib/util";
import {consultService} from "@/services/consult";
import {REMEWAL_PUBLIC_QUERY} from "@/lib/config";

export default {
  name: "consult-detail-renewal-part",
  components: {VIconArrowRight},
  props: {
    consult: {
      type: Object,
      default: () => Object.create(null)
    },
  },
  data() {
    return {
      info: {}
    }
  },
  created() {
    this.medicalRecordInfo();
  },
  methods: {
    async medicalRecordInfo() {
      this.info = await consultService.medicalRecordInfo(this.$route.params.id);
    },
    async handler() {
      /*const token = await thirdService.token({
        userId: this.consult.patId,
        userType: 'PAT',
        compatId: this.consult.compatId
      }, {
        thirdId: 5001
      })*/
      const token = await thirdService.RenewalToken();

      if (token) {
        let href = this.env.chufang + queryStrBuilder({
          ...REMEWAL_PUBLIC_QUERY,
          token
          //token, sourceType: 3, path: 'xfViewDrug', inquiryCode: this.consult.consultId
        });
        href += `#/myList/list`;
        location.href = href
      }
    },
    isYichang(content) {
      return content === '异常'
    }
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/renewal/components/consult-detail-renewal-part.vue